import { render, staticRenderFns } from "./profileMainBox.vue?vue&type=template&id=12663f95&"
import script from "./profileMainBox.vue?vue&type=script&lang=js&"
export * from "./profileMainBox.vue?vue&type=script&lang=js&"
import style0 from "./profileMainBox.vue?vue&type=style&index=0&id=12663f95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports